import * as ReduxObservable from 'redux-observable'
import * as App from '../../app'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as AddEditModal from './add-edit-modal/constants'
import * as Constants from './constants'

const leadTextFilterSelector: IsActive.FilterSelector = (state: ApplicationState) => state.leadText.view.filter
const leadTextdateSelector: any = (state: ApplicationState) => state.contentCalendar.data.selectedDate

type OnEnter = ReduxObservable.Epic<Request.RequestAction, ApplicationState>
const onEnter: OnEnter = (action$, store, {history}: App.Dependencies) =>
  action$.ofType(Router.ON_ENTER, AddEditModal.FormConstants[Form.SAVE_COMPLETE])
    .filter(() => history.location.pathname.startsWith(Menu.CONTENT_LEAD_TEXT_URL))
    .map(store.getState)
    .map((state) => {
      return Actions.fetchLeadTexts(state.app.selectedCommunity, leadTextFilterSelector(state) )
    })

export const epic = ReduxObservable.combineEpics(
  onEnter,
  IsActive.createStatusUpdateEpic(Constants.LEAD_TEXT_STATUS_UPDATE, Actions.updateLeadTextStatus),
  IsActive.createNavigateToPageEpic(Menu.CONTENT_CALENDAR_URL, Actions.fetchLeadTextByDate, leadTextdateSelector),
  IsActive.createFilterChangeEpic(Constants.FETCH_LEAD_TEXT, Actions.fetchLeadTexts, leadTextFilterSelector),
  IsActive.createDateChangeEpic(IsActive.UPDATE_SELECTED_DATE, Actions.fetchLeadTextByDate, leadTextdateSelector),
)



// WEBPACK FOOTER //
// ./src/pages/lead-text/epics.ts